import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { ModalWrapper } from '@/modules/perseo-billing/components';
import { setIsClubParisModalOpen } from '@/modules/perseo-billing/store/slices/billing';
import {
  Button,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export const ModalClubParis = () => {
  const dispatch = useAppDispatch();

  const isClubParisModalOpen = useAppSelector(
    (state) => state.billing.isClubParisModalOpen
  );

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const modalContent = (
    <ModalWrapper
      size="sm"
      fullWidth
      open={!!isClubParisModalOpen}
      onClose={() => dispatch(setIsClubParisModalOpen(null))}
      roundedType="FIXED_BOTTOM"
    >
      <div className="co-w-full co-flex co-flex-col co-pb-32px">
        <div className="co-flex co-flex-col co-py-24px co-px-16px co-gap-16px">
          <div className="co-w-full co-flex co-justify-between">
            <div className="co-flex co-gap-8px co-items-center">
              <Icon
                icon="InformationIcon"
                width={24}
                height={24}
                className="co-min-w-24px co-min-h-24px co-fill-current co-text-blue-500"
              />
              <Typography size="h2" weight="semibold">
                ¿Qué es Club Paris?
              </Typography>
            </div>
            <Button
              onClick={() => dispatch(setIsClubParisModalOpen(null))}
              icon="CloseIcon"
            />
          </div>
          <Divider />
        </div>
        <Typography size="h4" className="co-px-16px">
          Son clubes de beneficios para acompañarte en momentos especiales.
          Conócelos en la sección Mundo Paris de nuestra web.
        </Typography>
        <div className="co-w-full co-flex co-pt-32px co-px-16px">
          <Button
            pl={32}
            pr={32}
            variant="contained"
            color="primary"
            type="button"
            fullWidth
            onClick={() => dispatch(setIsClubParisModalOpen(null))}
          >
            Entendido
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );

  const rootClubParisModal = document.getElementById('modal-club-paris-info');
  return (
    isMounted &&
    rootClubParisModal &&
    createPortal(modalContent, rootClubParisModal)
  );
};
